import { RichiestaPubblicaDtoRichiesta } from '@framework/api-client';
import { SubmissionLogic } from '@framework/frontoffice-submission';
import { useTranslation } from '@framework/i18n';
import { DividerTitleElement, VerticalSpace } from '@framework/ui';
import { Col, Row } from 'antd';
import { DescriptionItem } from './DescriptionItem';

export interface ISubmissionDataViewProps {
  submission?: RichiestaPubblicaDtoRichiesta;
}

/**
 * ...
 */
export function SubmissionDataView(props: ISubmissionDataViewProps) {
  const { submission } = props;
  const { t } = useTranslation();

  if (!submission) return null;

  const applicants = SubmissionLogic.getApplicant(submission);

  return (
    <div>
      <DividerTitleElement
        title={t(
          'observation-details.dati-della-richiesta',
          'Dati della Richiesta',
        )}
        removeTopMargin
      />
      <Row>
        <Col span={12}>
          <DescriptionItem
            label={t('observation-details.domanda', 'Domanda')}
            value={submission?.titoloTipoDomanda ?? '-'}
          />
        </Col>
        {/* <Col span={6}>
          <DescriptionItem
            label={t(
              'observation-details.numero-istanza',
              'Numero Istanza',
            )}
            value={submission?.progressivo ?? '-'}
          />
        </Col> */}
        {applicants && (
          <Col span={6}>
            <DescriptionItem
              label={t('observation-details.titolare', 'Titolare')}
              value={applicants.mainOwner ?? '-'}
            />
          </Col>
        )}
      </Row>
      <VerticalSpace size={12} />
      {applicants && applicants.multipleApplicants && (
        <Row>
          <Col span={24}>
            <DescriptionItem
              label={t('observation-details.altri-titolari', 'Altri Titolari')}
              value={applicants.others?.join(', ') ?? '–'}
            />
          </Col>
        </Row>
      )}
    </div>
  );
}
